export default "/images/vendor/@coreui/icons/svg/flag/cif-am.svg?dfa7a5990762316f1defb620df739bf2";